export default __webpack_public_path__ + "static/media/city_img_sydney.5ff44e01.png";